import i18n from "../../language/i18n";
import { IStatusErrorProperties } from "../../properties/IErrorProperties";
import Icon from "../icons/Icon";

const StatusError = ({
  statusCode,
  statusText,
  textSize,
  tone = "danger",
  icon,
  helpText,
}: IStatusErrorProperties) => {
  // textSize kept for API compatibility — the hierarchy is fixed now.
  void textSize;

  return (
    <div className={`serr-wrap serr-tone-${tone}`}>
      {icon ? (
        <div className="serr-pill" aria-hidden="true">
          <span className="serr-pill-ring" />
          <Icon name={icon} size={30} />
        </div>
      ) : null}
      <span className="serr-eyebrow">{i18n.t("ooops_text")}</span>
      <div className="serr-body">
        {statusCode ? <p className="serr-code">{statusCode}</p> : null}
        <p className="serr-message">
          {statusText || i18n.t("unexcepted_error_text")}
        </p>
        {helpText ? <p className="serr-help">{helpText}</p> : null}
      </div>
    </div>
  );
};

export default StatusError;
